<script setup>
import {ref, onBeforeMount} from "vue";
import router from "@/router/index.js";
import createPhotographer from "./components/createPhotographer/index.vue"
import {getRoute} from "@/hooks/getRoute.js";
import {addServiceProviderIgnoreTenant} from "@/api/serviceProvider/ignoreTenant.js";
const {route} = getRoute()

onBeforeMount(() => {
  if (!route.query.tenantId) {
    loading.value = true
    ElMessage.error("暂无商家信息")
  } else if (!route.query.storeId) {
    loading.value = true
    ElMessage.error("暂无摄影服务商信息")
  } else {
    ruleForm.value.tenantId = route.query.tenantId
    ruleForm.value.storeId = route.query.storeId
  }
})
// 加载状态
const loading = ref(false)
/*表单信息相关*/
// 表单
const ruleForm = ref({
  tenantId: null,
  storeId: null,
  avatar: null,
  name: null,
  nameEn: null,
  phone: null,
  gender: null,
  summary: null,
  summaryEn: "Coming Soon ...",
  description: null,
  descriptionEn: "Coming Soon ...",
  providerType: "PHOTOGRAPHER",
  tagIdList: [],
  photographerPictureWorks: [],
  photographerVideoWorks: [],
  skillCertificates: []
})
// 处理创建摄影师
const handleCreatePhotographer = async () => {
  try {
    loading.value = true
    await addServiceProviderIgnoreTenant(ruleForm.value)
    ElMessage.success("新建成功")
    router.back()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <createPhotographer v-loading="loading" v-model="ruleForm" @success="handleCreatePhotographer"></createPhotographer>
</template>

<style lang="scss" scoped>

</style>
